// Matches old icon names from a icon id from E1
export const oldIconRegex = /^(fa3-icon|rjs[1-2]|vg-icon).*/;

export const BASE_ICON_V1_URL = 'https://s3.amazonaws.com/media.venngage.com/icons/v1/';
export const BASE_ICONS8_URL = '/infographics/icons8_download/';
export const BASE_ICONS8_ILLUSTRATION_URL = '/infographics/icons8_illustration_download/';
